import {DescriptionText, H1Text, H2Text} from "../../../../design";
import React from "react";
import {AmountDivideByHundred} from "../../../../helper";
import SmallScreenHeader from "../../../../components/smallscreen/header";
import currencyformatter from "../../../../utils/currencyformatter";

type Props = {
  payment: Object
}

const Header = (props:Props) => {
  const {payment} = props;
  return (
    <SmallScreenHeader>
      <H1Text>
        Payment Checkout
      </H1Text>
      <H2Text>
        Payment For
      </H2Text>
      <DescriptionText>
        {payment && payment.invoiceNumber}
      </DescriptionText>
      <H2Text>
        Amount Payable
      </H2Text>
      <DescriptionText fontSize="24px">
        {payment ? `${currencyformatter(payment.amount, payment.currency && payment.currency.name)}` : null }
      </DescriptionText>
    </SmallScreenHeader>
  )
};

export default Header;
